import { render, staticRenderFns } from "./activityCenter.vue?vue&type=template&id=606220ce&scoped=true&"
import script from "./activityCenter.vue?vue&type=script&lang=js&"
export * from "./activityCenter.vue?vue&type=script&lang=js&"
import style0 from "./activityCenter.vue?vue&type=style&index=0&id=606220ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606220ce",
  null
  
)

export default component.exports